import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArchiveFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.40039 2.49999C1.40039 1.88862 1.88902 1.39999 2.50039 1.39999H21.5004C22.1118 1.39999 22.6004 1.88862 22.6004 2.49999C22.6004 3.11136 22.1118 3.59999 21.5004 3.59999H21.0004V7.99997H3.00039V3.59999H2.50039C1.88902 3.59999 1.40039 3.11136 1.40039 2.49999ZM3.00039 9.19994V21.9999H21.0004V9.19994H3.00039ZM6.40041 15C6.40041 14.6686 6.66904 14.4 7.00041 14.4H17.0004C17.3318 14.4 17.6004 14.6686 17.6004 15C17.6004 15.3314 17.3318 15.6 17.0004 15.6H7.00041C6.66904 15.6 6.40041 15.3314 6.40041 15Z",
		fill: "currentColor"
	})
});
export default SvgArchiveFilled;
